import glam from 'glamorous';
import React from 'react';
import { ColumnsUtils } from 'module/Common';
import { ContentEmbed } from 'module/Model/Content';
import { Sizes } from 'module/View/Common';

export const Wrapper = glam.Div;

export const Background = glam.Div;

type Props = {
  item: ContentEmbed;
  itemIndex: number;
  cols: ColumnsUtils.ColumnsResult;
  waitForImage: (id: string) => void;
  imageReady: (id: string) => void;
};

export class Embed extends React.PureComponent<Props> {
  private wrapperRef: HTMLElement | null = null;

  render() {
    const { item, cols } = this.props;
    const contentWidth = cols.size(Sizes.allColumnsMinusOne(cols.nbOfColumns));
    return (
      <Background pointerEvents="all" width={contentWidth} backgroundColor={ContentEmbed.getColor(item)}>
        <Wrapper
          innerRef={((el: any) => this.registerWrapperRef(el)) as any}
          dangerouslySetInnerHTML={{
            __html: ContentEmbed.getElem(item),
          }}
        />
      </Background>
    );
  }

  private registerWrapperRef(el: HTMLElement | null): void {
    this.wrapperRef = el;
    if (this.wrapperRef !== null) {
      const iframe: HTMLIFrameElement = this.wrapperRef.children[0] as any;
      if (iframe) {
        const { cols, item } = this.props;
        const contentWidth = cols.size(Sizes.allColumnsMinusOne(cols.nbOfColumns));
        // full content width if fullWidth
        const elemRatio = ContentEmbed.isFullWidth(item) ? 1 : 2 / 3;
        const elemWidth = contentWidth * elemRatio;
        const ratio = ContentEmbed.getRatio(item);
        const elemHeight = elemWidth / ratio;
        iframe.width = Math.floor(elemWidth).toString();
        iframe.height = Math.floor(elemHeight).toString();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/View/Content/component/ContentItems/items/Embed.tsx